import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import { createPinia } from "pinia";
import InlineSvg from "vue-inline-svg";
import Toast from "vue-toastification";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import PrimeVue from "primevue/config";
import { definePreset } from "@primeuix/themes";
import Material from "@primeuix/themes/lara";
import fr from "./assets/js/locale/fr";
import "virtual:uno.css";
import "vue-toastification/dist/index.css";
import { FILE_PICKER_PT, TABLE_PT } from "./assets/js/helpers";
import KeyFilter from "primevue/keyfilter";
import Tooltip from "primevue/tooltip";
import DialogService from "primevue/dialogservice";
import { FilterService } from "@primevue/core/api";

FilterService.register("allow-all", () => true);
const preset = definePreset(Material, {
	semantic: {
		primary: {
			"50": "#f3f7fb",
			"100": "#e3eef6",
			"200": "#cde2f0",
			"300": "#abcfe5",
			"400": "#83b6d7",
			"500": "#659ccc",
			"600": "#5889c1",
			"700": "#4772ae",
			"800": "#3f5d8e",
			"900": "#364f72",
			"950": "#253146",
		},
		secondary: {
			"50": "#fefce8",
			"100": "#fdf9c4",
			"200": "#fbef8d",
			"300": "#f9df4b",
			"400": "#f5cc1a",
			"500": "#e5b30d",
			"600": "#c68a08",
			"700": "#9e630a",
			"800": "#824e11",
			"900": "#6f4014",
			"950": "#412107",
		},

		sky: {
			"50": "#eef7ff",
			"100": "#daecff",
			"200": "#bcdeff",
			"300": "#8fcbff",
			"400": "#5aadff",
			"500": "#338bfe",
			"600": "#2c75f4",
			"700": "#1555e0",
			"800": "#1845b5",
			"900": "#1a3e8e",
			"950": "#142757",
		},
		formField: {
			paddingY: "0.2rem",
		},
	},
	components: {
		button: {
			root: {
				borderRadius: "35px",
			},
		},
		chip: {
			root: {
				borderRadius: "35px",
			},
		},
		floatlabel: {
			over: {
				active: {
					top: "-1.125rem",
				},
			},
		},
		dialog: {
			content: {
				padding: "0",
			},
		},
	},
});
const pinia = createPinia();
const app = createApp(App);

app.directive("tooltip", Tooltip);
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(PrimeVue, {
	theme: {
		preset,
		options: { darkModeSelector: false },
	},
	pt: {
		DataTable: TABLE_PT,
		FilePicker: FILE_PICKER_PT,
		ProgressSpinner: {
			root: {
				style: {
					width: "2rem",
					height: "2rem",
				},
			},
		},
		Avatar: {
			image: {
				style: {
					objectFit: "cover",
				},
			},
		},
		Dialog: {
			content: "remove-dialog",
		},
	},
	locale: fr,
});
app.use(DialogService);

app.component("InlineSvg", InlineSvg);

const options = {
	position: "bottom-right",
	timeout: 5000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: true,
	closeButton: false,
	icon: false,
	rtl: false,
	toastClassName: "my-custom-toast-class",
};

app.directive("keyfilter", KeyFilter);
app.use(Toast, options);
// if (import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY) {
// 	app.use(VueReCaptcha, {
// 		siteKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY,
// 		loaderOptions: {
// 			autoHideBadge: false,
// 		},
// 	});
// }

app.mount("#app");
